module.exports = __webpack_public_path__ + "static/media/nsbe_detroit_profile.2b40d7e1.jpeg";